import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IDriverBreak extends IBaseEntity {
    id?: number;
    driverName?: any;
    driverId?: number;
    duration?: number;
    startTime?: Date;
    endTime?: Date;
    latitude?: number;
    longitude?: number;
    notes?: string;
}

export class DriverBreak extends BaseEntity implements IDriverBreak {
    id?: number;
    driverName?: any;
    driverId?: number;
    duration?: number;
    startTime?: Date;
    endTime?: Date;
    latitude?: number;
    longitude?: number;
    notes?: string;

    constructor(driverRequest?) {
        super();
        if (driverRequest) {
            this.id = driverRequest.id;
            this.driverId = driverRequest.driverId;
            this.driverName = driverRequest.driverName;
            this.duration = driverRequest.duration;
            this.startTime = driverRequest.startTime;
            this.endTime = driverRequest.endTime;
            this.latitude = driverRequest.latitude;
            this.longitude = driverRequest.longitude;
            this.notes = driverRequest.notes;
        }
    }

    clone(): DriverBreak {
        return new DriverBreak(this);
    }

    get discriminator(): any {
        return this.id;
    }
}
